import React, { useState } from "react";
import { Grid, Box, Button, FormLabel, TextField, Typography } from "../../../components/ui";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";

interface Prop {
  onClose: () => void;
}
const NodeForm: React.FC<Prop> = ({ onClose }) => {
  const [formData, setFormData] = useState<any>(null);

  const handleChage = (field: string, value: string) => {
    setFormData((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      const resp: any = await axiosInstance.post("/api/node", formData);
      if (resp.status === 200) {
        onClose();
        toast.success("Node created successfully");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };
  return (
    <div>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#1F2937">
            Add Node
          </Typography>
        </Grid>

        <Grid size={12}>
          <Box display={"grid"} width={"100%"}>
            <FormLabel>Node Name</FormLabel>
            <TextField
              size="small"
              id="outlined-basic"
              variant="outlined"
              value={formData?.visitor_name}
              onChange={(e: any) => handleChage("node_name", e?.target.value)}
            />
          </Box>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"end"}>
          {" "}
          <Box display={"display"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mx: 1, bgcolor: "#1F2937" }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="outlined"
              sx={{ color: "#1F2937", borderColor: "#1F2937" }}
              onClick={() => onClose}
            >
              Close
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default NodeForm;
